import { FolderOpenFilled, FolderOutlined } from '@ant-design/icons';
import { Badge, Flex } from 'antd';
import React, { useMemo, useState } from 'react';

const FodlersCategories = ({
  categories = [],
  onCategorySelect,
  selectedCategory,
}) => {
  const [hoveredId, setHoveredId] = useState(null);

  const selectedId = useMemo(
    () => selectedCategory?.id,
    [selectedCategory?.id]
  );

  return (
    <Flex vertical gap={4}>
      {categories.map((category) => {
        const isSelected = selectedId === category.id;
        const isHovered = hoveredId === category.id;

        return (
          <Flex
            key={category.id}
            onClick={() => onCategorySelect(category)}
            onMouseEnter={() => setHoveredId(category.id)}
            onMouseLeave={() => setHoveredId(null)}
            justify="space-between"
            align="center"
            style={{
              cursor: 'pointer',
              padding: '12px 8px',
              borderRadius: '4px',
              backgroundColor:
                isHovered || isSelected ? '#f5f5f5' : 'transparent',
              transition: 'background-color 0.2s',
            }}
          >
            <Flex align="center" gap={8}>
              {isSelected ? (
                <FolderOpenFilled style={{ fontSize: '16px' }} />
              ) : (
                <FolderOutlined style={{ fontSize: '16px' }} />
              )}
              <span style={{ fontSize: '14px' }}>{category.name}</span>
            </Flex>
            <Badge
              count={category.count || 0}
              showZero
              style={{
                backgroundColor: '#d9d9d9',
                color: '#595959',
                fontSize: '12px',
                minWidth: '20px',
                height: '20px',
                lineHeight: '20px',
              }}
            />
          </Flex>
        );
      })}
    </Flex>
  );
};

export default FodlersCategories;
